// src/components/hero/Hero.jsx
import { useEffect, useRef, useState } from 'react';
import video from '../../Assets/videos/Hospitalvideosfinal.mp4';

const headingWords = [
  'Bringing',
  'Back',
  'Your',
  'Happy',
  'Smile',
];

const Hero = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  const [visibleWords, setVisibleWords] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
  let revealInterval;
  let fadeTimeout;

  const revealDelay = 500; // ms per word

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        // Reveal words one by one
        revealInterval = setInterval(() => {
          setVisibleWords((prev) => {
            if (prev < headingWords.length) {
              return prev + 1;
            } else {
              clearInterval(revealInterval);
              return prev;
            }
          });
        }, revealDelay);

        // Fade out AFTER full sentence is visible
        fadeTimeout = setTimeout(() => {
          setFadeOut(true);
        }, headingWords.length * revealDelay + 1500); // extra pause

        observer.disconnect();
      }
    },
    { threshold: 0.2 }
  );

  if (ref.current) observer.observe(ref.current);

  return () => {
    clearInterval(revealInterval);
    clearTimeout(fadeTimeout);
    observer.disconnect();
  };
}, []);
useEffect(() => {
  if (!videoLoaded) return;

  let revealInterval;
  let fadeTimeout;

  const revealDelay = 500;

  revealInterval = setInterval(() => {
    setVisibleWords((prev) => {
      if (prev < headingWords.length) {
        return prev + 1;
      } else {
        clearInterval(revealInterval);
        return prev;
      }
    });
  }, revealDelay);

  fadeTimeout = setTimeout(() => {
    setFadeOut(true);
  }, headingWords.length * revealDelay + 1500);

  return () => {
    clearInterval(revealInterval);
    clearTimeout(fadeTimeout);
  };
}, [videoLoaded]);


  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
     <video
  autoPlay
  loop
  muted
  playsInline
  preload="auto"
  onLoadedData={() => setVideoLoaded(true)}
  className="absolute inset-0 w-full h-[84%] object-cover"
>
  <source src={video} type="video/mp4" />
</video>

      {/* Overlay */}
      {/* <div className="absolute inset-0 bg-black/40" /> */}

      {/* Content */}
      <div
  ref={ref}
  className={`relative z-10 flex flex-col items-center justify-center text-center ml-10 mb-[10%] px-4 md:px-6 max-w-5xl mx-auto
    transition-opacity duration-1000 ease-in-out
    ${fadeOut ? 'opacity-0' : 'opacity-100'}
  `}
>

        <div className="absolute inset-0 bg-gradient-to-t from-white/90 via-white/70 to-white/40 h-[120%]" />

        <h1 className="flex flex-wrap justify-center  gap-2 md:gap-3 text-4xl sm:text-5xl md:text-6xl font-bold text-red-800 leading-tight">
          {headingWords.map((word, index) => (
            <span
  key={index}
  className={`inline-block transition-transform duration-500 ease-out
    ${index < visibleWords
      ? 'translate-y-0'
      : 'hidden translate-y-6'
    }
  `}
>
  {word}
</span>

          ))}
        </h1>
      </div>
    </section>
  );
};

export default Hero;
